import React from "react";

export default function Table_Style() {
  return <div>Excel_Table_Style</div>;
}
